import emailValidation from 'PlugAndPlay/_global/js/emailValidation';

export default function _share() {
    const copyButtons = document.querySelectorAll('.button-copy');
    const pageTitleComplete = document
        .querySelector('meta[name="dcterms.title"]')
        .getAttribute('content');
    const pageTitle = pageTitleComplete.replace('Road Safety Education - ', '');

    let type;
    if (document.querySelector('meta[name="resource.tile.type"]')) {
        const types = {
            typeLessonPlan: 'Lesson Plan',
            typeProgram: 'Program',
            typePolicy: 'Policy',
            typeAdditionalResource: 'Additonal Resource',
        };
        const typeRaw = document
            .querySelector('meta[name="resource.tile.type"]')
            .getAttribute('content');

        type = types[typeRaw];
    }

    const emailTitle = `${type} - ${pageTitle}`;

    const pageUrl = document.URL;
    const pageHtml = document.querySelector('html');

    let emailOutput;
    const desktopTarget = document.querySelector('.share-modal.share');
    if (desktopTarget) {
        const desktopMessage = desktopTarget.dataset.emailbody;
        const combinedDesktopEmailBody = `${desktopMessage} \n\n${pageUrl}`;
        emailOutput = encodeURIComponent(combinedDesktopEmailBody);
    }

    // mobile share button click
    const mobileShareButton = document.getElementById('mobile-share');

    function openEmailClient(email, emailBody) {
        window.location = `mailto:${
            email || ''
        }?subject=${emailTitle}&body=${emailBody}`;
    }

    if (mobileShareButton) {
        mobileShareButton.addEventListener('click', () => {
            openEmailClient('', emailOutput);
        });
    }

    // mobile share button click
    function copyUrlToClipboard() {
        navigator.clipboard.writeText(pageUrl);
        // fade in and out "Copied" message
        const copiedMessage = document.querySelectorAll(
            '.share-copied-tooltip_wrapper'
        );

        copiedMessage.forEach((el) => {
            el.classList.add('fade');
            setTimeout(() => {
                el.classList.remove('fade');
            }, 1500);
        });
    }
    copyButtons.forEach((element) => {
        element.addEventListener('click', copyUrlToClipboard);
    });

    // desktop modal open
    const openModalButton = document.querySelector('.js-share-open');
    const shareModal = document.querySelector('.share-modal.share');

    function openShareModal() {
        shareModal.classList.add('open');
        pageHtml.style.overflow = 'hidden';
    }

    if (openModalButton) {
        openModalButton.addEventListener('click', openShareModal);
    }

    // desktop modal close
    const modalXClose = document.querySelectorAll('.share-modal_close');
    const modalBackground = document.querySelectorAll(
        '.share-modal_background'
    );
    const modalBody = document.querySelectorAll('.share-modal_container');

    function closeShareModal() {
        shareModal.classList.remove('open');
        pageHtml.style.overflow = 'auto';
    }

    function ignoreClick(e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
    }

    /* Close modal on esc key */

    document.addEventListener('keydown', (evt) => {
        if (shareModal.classList.contains('open') && evt.key === 'Escape') {
            closeShareModal();
        }
    });

    modalXClose.forEach((el) => {
        el.addEventListener('click', closeShareModal);
    });
    modalBackground.forEach((el) => {
        el.addEventListener('click', closeShareModal);
    });
    modalBody.forEach((el) => {
        el.addEventListener('click', ignoreClick);
    });

    // desktop email input label animation
    const emailInput = document.getElementById('share-email');

    if (emailInput) {
        emailInput.addEventListener('focus', () => {
            emailInput.closest('.form-group').classList.add('focused');
        });
        emailInput.addEventListener('blur', () => {
            emailInput.closest('.form-group').classList.remove('focused');
            if (emailInput.value !== '') {
                document
                    .querySelector('.share-form_email label')
                    .classList.add('hide');
            } else {
                document.querySelector('label.hide').classList.remove('hide');
            }
        });
    }

    // desktop share email validation and email client -click
    const modalShareButton = document.getElementById('modal-share-button');

    if (modalShareButton) {
        modalShareButton.addEventListener('click', () => {
            const emailForValidation = emailInput.value;
            if (emailValidation(emailForValidation)) {
                document
                    .querySelector('.email-invalid')
                    .classList.remove('show');
                openEmailClient(emailForValidation, emailOutput);
            } else {
                document.querySelector('.email-invalid').classList.add('show');
            }
        });
    }
    // desktop share email validation and email client - enter after email
    const emailInputField = document.getElementById('share-email');
    if (emailInputField) {
        emailInputField.addEventListener('keyup', ({ key }) => {
            if (key === 'Enter') {
                const emailForValidation = emailInputField.value;
                if (emailValidation(emailForValidation)) {
                    document
                        .querySelector('.email-invalid')
                        .classList.remove('show');
                    openEmailClient(emailForValidation, emailOutput);
                } else {
                    document
                        .querySelector('.email-invalid')
                        .classList.add('show');
                }
            }
        });
    }

    // desktop copy content, and share
    const copyInputPlaceholder = document.getElementById('page-url');
    if (copyInputPlaceholder) {
        copyInputPlaceholder.innerText = pageUrl;
    }
}

window.addEventListener('DOMContentLoaded', _share);
